import { forwardRef } from "react";

import {
  DISMISSABLE_ALERT_DEFAULTS,
  DISMISSABLE_ALERT_VARIANT_CLASS_MAP,
  type TDismissableAlertProps,
} from "@/ui/components/feedback/DismissableAlert/DismissableAlert.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";
import { AlertWrapper } from "../Alert/AlertWrapper";
import { AlertTitle } from "../Alert/AlertTitle";
import { AlertBody } from "../Alert/AlertBody";

export const DismissableAlert = forwardRef<HTMLDivElement, TDismissableAlertProps>(
  (
    {
      children,
      className,
      asset,
      title,
      variant = DISMISSABLE_ALERT_DEFAULTS.variant,
      ...props
    },
    ref,
  ) => (
    <AlertWrapper
      {...props}
      data-component="DismissableAlert"
      ref={ref}
      asset={asset}
      className={cn(
        DISMISSABLE_ALERT_VARIANT_CLASS_MAP[variant],
        className,
      )}>
      { asset ? (
        <div className="col-start-1 row-start-1 self-center">
          <Icon
            aria-hidden="true"
            className="shrink-0"
            icon={asset}
            size="sm"
          />
        </div>
      ) : null }
      <AlertTitle title={title} asset={asset} />
      <AlertBody asset={asset} hasTitle={!!title}>{ children }</AlertBody>
    </AlertWrapper>
  ),
);

DismissableAlert.displayName = "DismissableAlert";
